import React, { useState, useEffect } from 'react';

function PageLoader() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const handleLoad = () => {
      setTimeout(() => setHidden(true), 1200);
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
      return () => window.removeEventListener('load', handleLoad);
    }
  }, []);

  useEffect(() => {
    const fallback = setTimeout(() => setHidden(true), 3000);
    return () => clearTimeout(fallback);
  }, []);

  return (
    <div className={`page-loader ${hidden ? 'hidden' : ''}`}>
      <div className="loader-content">
        <div className="loader-logo">AGRO-INVEST</div>
        <div className="loader-spinner"></div>
        <p className="loader-text">Loading your agricultural future...</p>
      </div>
    </div>
  );
}

export default PageLoader;
